// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ae03c749","839":"b0cf6390"}[chunkId] + ".chunk.js";
};